<section class="cancel-job-confirm" role="status" aria-live="polite">
  <p class="cancel-job-confirm__message">
    If you cancel this job, the documents and information you provided will not be translated.
  </p>
  <p class="cancel-job-confirm__message">
    Are you sure you want to cancel this translation job?
  </p>

  <div class="cancel-job-confirm__actions">
    <button
      type="button"
      class="cancel-job-confirm__btn cancel-job-confirm__btn--secondary"
      [disabled]="processing()"
      data-testid="cancel-job-confirm-no"
      (click)="onNo()"
    >
      No
    </button>
    <button
      type="button"
      class="cancel-job-confirm__btn cancel-job-confirm__btn--primary"
      [disabled]="processing()"
      data-testid="cancel-job-confirm-yes"
      (click)="onYes()"
    >
      Yes
    </button>
  </div>

  @if (processing()) {
    <div class="cancel-job-confirm__overlay" data-testid="cancel-job-loading-inline">
      <app-spinner [display]="true" [diameter]="88"></app-spinner>
    </div>
  }
</section>
